
import axios from "axios";
import { getAuthorizationToken } from "../config/user";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const getUserSessionsList = async () => {
  try {
    const response = await axios({
      url: `${REACT_APP_API_URL}/my-sessions`,
      method: 'get',
      headers: getAuthorizationToken()
    });
    return response.data
    // console.log(response.data);
  } catch (err) {
    console.log(err.response?.data || err.message);
  }
};


  const terminateSession = async (sessionid,removeall) =>
  {
    const data = {
        sessionIds : sessionid,
        removeAllOther:removeall
    }
    try {
        const response = await axios({
          url: `${REACT_APP_API_URL}/remove-sessions`,
          method: 'DELETE',
          headers: getAuthorizationToken(),
          data:data
        });
        console.log(response.data);
      } catch (err) {
        console.log(err.response?.data || err.message);
      } 
  }


export const  SessionManagmentServices  = {
    getUserSessionsList,
    terminateSession
}
